import React from "react";

export default function ResultBackButton(props) {
    return (
        <div className="shadow md:w-36 md:mx-auto cursor-pointer font-bold my-0.5 mx-0 p-2 md:px-2 md:py-0.5 md:rounded-sm text-center bg-city-green-medium text-city-white hover:bg-city-green-dark" onClick={() => { props.setResults([]); props.setAddress(null) }}>Back</div>
    )
}